export const features = [
  {
    id: 1,
    icon: 'ri-movie-2-line',
    title: '海量片库每日更新',
    desc: '收录超过十万部电影资源，涵盖动作、喜剧、科幻、悬疑、爱情、动画等全类型，每日同步更新最新院线大片与经典老片，被窝影院电影大全免费看，满足各类影迷需求。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速加载不缓冲',
    desc: '采用全球分布式 CDN 加速节点，支持 4K 超清画质流畅播放，无论手机还是电脑，被窝影院均实现不缓冲流畅在线观看，告别卡顿与等待。',
  },
  {
    id: 3,
    icon: 'ri-advertisement-line',
    title: '纯净观影零广告',
    desc: '被窝影院坚持电影大全无广告原则，全站无弹窗、无贴片、无浮动广告，让每一位影迷都能沉浸在院线电影免费经典电影全集的纯粹观影体验中。',
  },
];

export const comments = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photography%20of%20young%20Chinese%20man%20in%20casual%20style%2C%20warm%20lighting%2C%20clean%20studio%20background%2C%20friendly%20expression%2C%20soft%20natural%20look&width=120&height=120&seq=avatar-user-01&orientation=squarish',
    name: '电影虫子小李',
    rating: 5,
    date: '2026-07-28',
    content: '被窝影院真的太良心了！之前在其他平台看个电影要等三分钟广告，这边直接点开就能看，画质也很清晰。最新电影免费看的承诺真不是吹的，上周刚上的新片这边第二天就有了，已经推荐给身边所有朋友了。',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20elegant%20Chinese%20woman%20with%20warm%20smile%2C%20minimal%20studio%20lighting%2C%20clean%20white%20background%2C%20natural%20makeup%2C%20soft%20and%20friendly%20expression&width=120&height=120&seq=avatar-user-02&orientation=squarish',
    name: '周末影迷小雅',
    rating: 5,
    date: '2026-07-25',
    content: '作为一个重度影迷，被窝影院的片库真的让我惊喜。高分电影在线随便搜，很多冷门经典都能找到。最感动的是电影大全无广告，这个体验在其他平台根本不敢想，以后看电影就锁定这里了！',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20stylish%20Chinese%20young%20man%20with%20glasses%2C%20intellectual%20look%2C%20warm%20indoor%20lighting%2C%20clean%20minimal%20backdrop%2C%20confident%20but%20approachable%20expression&width=120&height=120&seq=avatar-user-03&orientation=squarish',
    name: '阿杰的电影笔记',
    rating: 4,
    date: '2026-07-22',
    content: '院线电影免费经典电影全集这个口号真不是盖的！从好莱坞大片到国产文艺片，类型很全。不缓冲流畅在线观看体验也很棒，我家网速一般但基本没卡过。唯一希望后续能加上弹幕功能，跟其他影迷一起看会更有意思。',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20warm%20Chinese%20woman%20in%20cozy%20home%20setting%2C%20soft%20natural%20light%2C%20relaxed%20casual%20style%2C%20genuine%20friendly%20smile%2C%20lifestyle%20photography&width=120&height=120&seq=avatar-user-04&orientation=squarish',
    name: '宅家观影达人',
    rating: 5,
    date: '2026-07-20',
    content: '被窝影院名副其实！冬天窝在被窝里用手机打开就能看，夏天躺沙发上投屏到大电视。电影大全免费看不是说说而已，是真的全免费。页面也很清爽没有乱七八糟的广告，观影体验一级棒，五星好评不解释！',
  },
];

export const aboutData = {
  title: '被窝影院 — 让好电影触手可及',
  paragraphs: [
    '被窝影院成立于 2024 年，是国内领先的免费在线观影平台。我们致力于为全国影迷提供最新电影免费看、高分电影在线的高品质观影服务，打造一个电影大全无广告的纯净观影空间。无论您喜欢院线电影免费经典电影全集，还是小众艺术佳作，被窝影院都能满足您的需求。',
    '我们的技术团队持续优化播放引擎，确保每一位用户都能享受不缓冲流畅在线观看的极致体验。平台覆盖动作片、喜剧片、爱情片、科幻片、恐怖片、动画片等全品类内容，日更新量超过 50 部，片库总量已突破十万部，是您随时随地发现好电影的最佳选择。',
    '被窝影院始终坚持以用户体验为核心，不设置任何付费门槛，不推送任何干扰广告，致力于成为国内最干净、最流畅、最全面的免费电影平台。',
  ],
};

export const cards = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=epic%20action%20movie%20scene%20with%20explosive%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20golden%20and%20red%20tones%2C%20movie%20poster%20aesthetic%2C%20high%20contrast%2C%20professional%20film%20photography%20style&width=800&height=600&seq=card-movie-action-01&orientation=landscape',
    tag: '动作大片',
    title: '热血动作',
    desc: '从好莱坞顶级制作到亚洲功夫经典，肾上腺素飙升的极致体验。',
    count: '12,800+',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=bright%20colorful%20comedy%20movie%20scene%2C%20playful%20cinematography%2C%20warm%20lighting%2C%20humorous%20mood%2C%20vibrant%20colors%2C%20film%20poster%20style%20with%20soft%20background&width=800&height=600&seq=card-movie-comedy-02&orientation=landscape',
    tag: '喜剧天地',
    title: '爆笑喜剧',
    desc: '国内外高分喜剧片一网打尽，笑到停不下来的欢乐时光。',
    count: '9,500+',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=futuristic%20science%20fiction%20movie%20visual%2C%20space%20and%20technology%20theme%2C%20cinematic%20lighting%20with%20cool%20tones%2C%20film%20poster%20aesthetic%2C%20atmospheric%20and%20immersive%2C%20professional%20photography&width=800&height=600&seq=card-movie-scifi-03&orientation=landscape',
    tag: '科幻殿堂',
    title: '科幻巨制',
    desc: '穿越星际、探索未知，国内外顶尖科幻大片震撼呈现。',
    count: '6,300+',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=romantic%20movie%20scene%20with%20soft%20golden%20hour%20lighting%2C%20intimate%20cinematic%20composition%2C%20warm%20tender%20mood%2C%20film%20poster%20style%2C%20dreamy%20atmosphere%2C%20beautiful%20photography&width=800&height=600&seq=card-movie-romance-04&orientation=landscape',
    tag: '爱情经典',
    title: '浪漫爱情',
    desc: '从青涩初恋到刻骨铭心，每一帧都是心动的声音。',
    count: '8,200+',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=atmospheric%20horror%20thriller%20movie%20visual%2C%20dark%20moody%20lighting%2C%20suspenseful%20cinematic%20composition%2C%20film%20poster%20aesthetic%2C%20shadows%20and%20mystery%2C%20professional%20photography%20style&width=800&height=600&seq=card-movie-horror-05&orientation=landscape',
    tag: '悬疑惊悚',
    title: '悬疑惊悚',
    desc: '烧脑反转、细思极恐，高智商悬疑片带你进入谜局。',
    count: '7,100+',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20animated%20film%20visual%20with%20rich%20colors%2C%20artistic%20composition%2C%20cinematic%20lighting%2C%20anime%20movie%20poster%20style%2C%20vibrant%20and%20emotional%2C%20professional%20quality&width=800&height=600&seq=card-movie-anime-06&orientation=landscape',
    tag: '动画精选',
    title: '动画佳作',
    desc: '从宫崎骏到皮克斯，每一部都是值得珍藏的动画艺术。',
    count: '5,400+',
  },
];

export const carouselItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=epic%20cinematic%20movie%20collage%20with%20dramatic%20lighting%2C%20film%20reel%20and%20projector%20elements%2C%20warm%20golden%20tones%2C%20movie%20marathon%20theme%2C%20professional%20film%20photography%2C%20cinematic%20atmosphere&width=1200&height=600&seq=carousel-feature-01&orientation=landscape',
    tag: '暑期特辑',
    title: '2026 暑期档热门大片盘点',
    desc: '这个夏天不容错过的十部院线级大片，被窝影院全网首发高清资源，陪你度过最燃暑假。从超级英雄到国漫崛起，每一部都值得二刷。',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=classic%20film%20noir%20cinematic%20composition%2C%20vintage%20movie%20aesthetic%2C%20black%20and%20white%20with%20warm%20accents%2C%20film%20history%20theme%2C%20elegant%20and%20timeless%2C%20professional%20photography&width=1200&height=600&seq=carousel-feature-02&orientation=landscape',
    tag: '经典重温',
    title: '影史百年：不可错过的经典电影全集',
    desc: '从默片时代到数字电影，我们精选百年影史上最具影响力的经典作品。被窝影院电影大全免费看，让经典触手可及。',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20domestic%20film%20cinematic%20visual%2C%20cultural%20and%20artistic%20composition%2C%20warm%20rich%20colors%2C%20Chinese%20cinema%20theme%2C%20dramatic%20lighting%2C%20professional%20film%20photography%2C%20elegant%20aesthetic&width=1200&height=600&seq=carousel-feature-03&orientation=landscape',
    tag: '国产之光',
    title: '国产电影崛起：近年必看高分华语片',
    desc: '华语电影正在迎来黄金时代。从现实题材到类型片突破，被窝影院精选近三年豆瓣 8 分以上的高分电影在线合集，见证国产电影的崛起之路。',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Oscar%20award%20cinematic%20visual%2C%20prestigious%20film%20awards%20theme%2C%20golden%20statue%20and%20film%20elements%2C%20elegant%20luxurious%20lighting%2C%20professional%20photography%2C%20sophisticated%20movie%20aesthetic&width=1200&height=600&seq=carousel-feature-04&orientation=landscape',
    tag: '奖项巡礼',
    title: '奥斯卡与三大电影节获奖作品全集',
    desc: '金棕榈、金狮、金熊、奥斯卡 — 被窝影院整理了历年国际顶级电影节获奖作品，院线电影免费经典电影全集，带你看遍世界级好片。',
  },
];

export const appData = {
  title: '手机观影更自由',
  tagline: '被窝影院移动端 — 随时随地畅享高清电影',
  desc: '支持 iOS 与 Android 双平台，4G/5G/WiFi 全场景自适应码率。离线缓存功能让你在地铁、飞机上也能不缓冲流畅在线观看，真正实现被窝里看世界的梦想。',
  features: ['全高清画质', '智能推荐', '离线缓存', '投屏播放', '夜间模式', '无广告纯净'],
};

export const indexItems = [
  { id: 1, letter: 'A', title: '动作片', count: '2,860', link: '#cards' },
  { id: 2, letter: 'B', title: '喜剧片', count: '2,140', link: '#cards' },
  { id: 3, letter: 'C', title: '科幻片', count: '1,580', link: '#cards' },
  { id: 4, letter: 'D', title: '爱情片', count: '1,920', link: '#cards' },
  { id: 5, letter: 'E', title: '恐怖片', count: '1,340', link: '#cards' },
  { id: 6, letter: 'F', title: '动画片', count: '1,760', link: '#cards' },
  { id: 7, letter: 'G', title: '纪录片', count: '890', link: '#cards' },
  { id: 8, letter: 'H', title: '战争片', count: '720', link: '#cards' },
  { id: 9, letter: 'I', title: '悬疑片', count: '1,450', link: '#cards' },
];

export const updates = [
  {
    id: 1,
    date: '2026-07-30',
    title: '《星际迷航：新纪元》独家上线',
    desc: '科幻巨制《星际迷航：新纪元》在被窝影院全网首发，4K 超清画质，中英双语字幕，立即在线观看。',
  },
  {
    id: 2,
    date: '2026-07-28',
    title: '暑期动画专题重磅上线',
    desc: '集结《哪吒之魔童闹海》《深海2》《大圣归来2》等国产动画精品，适合全家一起观看的动画佳作合集。',
  },
  {
    id: 3,
    date: '2026-07-25',
    title: '播放引擎全面升级',
    desc: '被窝影院完成播放器核心引擎升级，加载速度提升 40%，4K 视频传输效率翻倍，观影体验更进一步。',
  },
  {
    id: 4,
    date: '2026-07-22',
    title: '经典港片修复计划启动',
    desc: '我们启动了经典港片数字修复项目，首批上线《重庆森林》《花样年华》《无间道》等 50 部高清修复版。',
  },
  {
    id: 5,
    date: '2026-07-20',
    title: '手机端适配方案全面优化',
    desc: '针对主流移动设备进行深度适配，横竖屏自动切换，手势控制更流畅，移动观影体验全面升级。',
  },
  {
    id: 6,
    date: '2026-07-18',
    title: '欧洲三大电影节获奖影片专区上线',
    desc: '从戛纳到威尼斯，历年欧洲三大电影节的获奖佳作专题专区正式上线，影迷不可错过的经典盛宴。',
  },
  {
    id: 7,
    date: '2026-07-15',
    title: '用户破千万，感恩回馈',
    desc: '被窝影院注册用户突破一千万！感谢每一位影迷的支持，我们将持续提供更优质的免费观影服务。',
  },
];

export const rankingItems = [
  { rank: 1, title: '星际迷航：新纪元', type: '科幻', score: 9.2, trend: 'up', hot: '🔥 128万' },
  { rank: 2, title: '无名之辈2', type: '喜剧', score: 8.9, trend: 'up', hot: '🔥 106万' },
  { rank: 3, title: '深海寻踪', type: '悬疑', score: 8.7, trend: 'new', hot: '🔥 95万' },
  { rank: 4, title: '烈火英雄：逆行者', type: '动作', score: 8.5, trend: 'up', hot: '89万' },
  { rank: 5, title: '爱情神话·续', type: '爱情', score: 8.4, trend: 'down', hot: '76万' },
  { rank: 6, title: '哪吒之魔童闹海', type: '动画', score: 8.8, trend: 'up', hot: '72万' },
  { rank: 7, title: '大漠孤烟', type: '战争', score: 8.3, trend: 'new', hot: '68万' },
];

export const faqItems = [
  {
    q: '被窝影院真的完全免费吗？',
    a: '是的，被窝影院始终坚持完全免费的运营理念。您无需注册会员、无需付费订阅，即可畅享平台上所有最新电影免费看和高分电影在线资源。我们通过品牌合作和内容授权维持运营，确保每位用户都能享受电影大全无广告的纯净体验。',
  },
  {
    q: '为什么被窝影院可以做到不缓冲流畅在线观看？',
    a: '我们投入了大量技术资源建设全球 CDN 分发网络，在国内部署了超过 200 个加速节点。同时采用智能码率自适应技术，根据您的网络状况自动匹配最佳画质，确保不缓冲流畅在线观看的丝滑体验。',
  },
  {
    q: '被窝影院的电影资源更新频率如何？',
    a: '被窝影院电影大全免费看的背后是一支专业的版权内容运营团队，每日更新超过 50 部影片。院线电影免费经典电影全集通常在院线下映后 30-60 天内上线，热门新片第一时间同步更新，确保您不错过任何一部好电影。',
  },
  {
    q: '支持哪些设备观看？画质最高能达到多少？',
    a: '被窝影院支持手机（iOS/Android）、平板、电脑（Windows/Mac）以及智能电视投屏观看。画质方面，大部分影片提供 1080P 高清，热门大片支持 4K 超清，并可根据您的网络环境自适应调整，保证最佳观影效果。',
  },
  {
    q: '需要下载 APP 吗？网页版和 APP 有什么区别？',
    a: '您可以直接在被窝影院网页版观看，无需安装任何软件。如果希望获得离线缓存、夜间模式、智能推荐等高级功能，可以下载被窝影院移动端 APP。两者内容完全同步，APP 在移动设备上提供更优化的手势操作和下载功能。',
  },
];

export const topics = [
  { id: 1, name: '暑期档', count: '2,860', color: 'accent' },
  { id: 2, name: '豆瓣高分', count: '5,420', color: 'primary' },
  { id: 3, name: '国产电影', count: '3,180', color: 'secondary' },
  { id: 4, name: '好莱坞大片', count: '4,250', color: 'accent' },
  { id: 5, name: '动画电影', count: '1,960', color: 'secondary' },
  { id: 6, name: '悬疑烧脑', count: '2,340', color: 'primary' },
  { id: 7, name: '经典重温', count: '3,750', color: 'accent' },
  { id: 8, name: '新片速递', count: '6,120', color: 'primary' },
  { id: 9, name: '获奖佳作', count: '1,880', color: 'secondary' },
];

export const mediaItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=film%20analysis%20video%20thumbnail%20style%2C%20movie%20scene%20breakdown%2C%20cinematic%20composition%20with%20text%20overlay%20area%2C%20warm%20lighting%2C%20professional%20film%20review%20aesthetic&width=800&height=500&seq=media-video-01&orientation=landscape',
    title: '《星际迷航》深度解说：隐藏细节全揭秘',
    duration: '28:45',
    views: '12.8万',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=movie%20behind%20the%20scenes%20thumbnail%2C%20film%20making%20documentary%20style%2C%20director%20working%20on%20set%2C%20cinematic%20behind%20scenes%20photography%2C%20warm%20professional%20lighting&width=800&height=500&seq=media-video-02&orientation=landscape',
    title: '幕后花絮：国产科幻大片的制作之路',
    duration: '35:12',
    views: '9.6万',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=classic%20film%20review%20video%20thumbnail%2C%20vintage%20movie%20analysis%2C%20film%20history%20documentary%20style%2C%20warm%20cinematic%20lighting%2C%20elegant%20professional%20aesthetic&width=800&height=500&seq=media-video-03&orientation=landscape',
    title: '百年经典：影史上最伟大的十部电影',
    duration: '42:18',
    views: '18.3万',
  },
];